import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT } from "const"
import { hasAccess } from "client/utils"
import { qidCompaniesRoute } from "client/parts/routes"
import {
    PRM_QID_COMPANY,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    Button,
} from "client/components"

const Form = () => {
    const company = useSelector((state: StoreType) => state.qidCompany.companyView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${qidCompaniesRoute}/${EDIT}/${company.id}`
    const editAccess = hasAccess(PRM_QID_COMPANY, EDIT)

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={company.logo || Images.qidCompanyLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={company.name} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[company.status]} readOnly />
                            </FormGroup>
                        </Col>
                        {
                            editAccess
                            && (
                                <Col xs={12}>
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
